var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "loading-inline-container", class: { show: _vm.visible } },
    [_vm._m(0)]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loading-content" }, [
      _c("div", { staticClass: "spinner" }, [
        _c("div", { staticClass: "spinner__item1" }),
        _vm._v(" "),
        _c("div", { staticClass: "spinner__item2" }),
        _vm._v(" "),
        _c("div", { staticClass: "spinner__item3" }),
        _vm._v(" "),
        _c("div", { staticClass: "spinner__item4" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }